import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { stepperActions } from "../../redux/reducers/stepperReducer";

const SFStep = ({ step, label, stepperName, loading = false, ...props }) => {
  const stepRef = useRef();
  const dispatch = useDispatch();
  const stepperReduxState = useSelector((state) => {
    return state.stepper.find((stepper) => stepper.name === stepperName);
  });

  useEffect(() => {
    if (
      stepperReduxState &&
      stepperReduxState.activeStep === step &&
      !loading
    ) {
      stepRef.current.onLoad({
        nextStep: stepperReduxState.nextStep,
        activeStep: stepperReduxState.activeStep,
        data: stepperReduxState.data,
      });
    }
  }, [stepperReduxState?.activeStep, loading]);

  useEffect(() => {
    if (
      stepperReduxState &&
      stepperReduxState.nextStep !== null &&
      stepperReduxState.activeStep === step &&
      stepperReduxState.nextStep !== step &&
      !loading
    ) {
      const onStepChangeHandler = async () => {
        const res = await stepRef.current.onStepChange({
          nextStep: stepperReduxState.nextStep,
          activeStep: stepperReduxState.activeStep,
          data: stepperReduxState.data,
        });
        if (res) {
          dispatch(stepperActions.changeStep({ data: res, name: stepperName }));
        } else {
          dispatch(stepperActions.resetNextStep({ name: stepperName }));
        }
      };
      onStepChangeHandler();
    }
  }, [stepperReduxState?.nextStep, loading]);

  if (!stepperReduxState || stepperReduxState?.activeStep !== step || loading) {
    return null;
  }

  return (
    <>
      {React.cloneElement(props.children, {
        ref: stepRef,
        props: props.children.props,
      })}
    </>
  );
};

SFStep.propTypes = {
  step: PropTypes.number,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  stepperName: PropTypes.string,
  //this property is used to prevent the step from loading until the setinitialdata in stepper is completed
  loading: PropTypes.bool,
};

export default SFStep;
